import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import { listFirmwaresUrl } from "../../config";
import api from "../../api";
import { IListFirmwares } from "../../common/types/firmwareTypes";

const LIST_FIRMWARES: string = "listFirmwares";

const initialState: IListFirmwares = {
  message: null,
  status: Status.IDLE,
  error: null,
  values: null,
};
export const fetchFirmwareData = createAsyncThunk(LIST_FIRMWARES, async () => {
  try {
    const listFirmwaresResponse = await api.get<IListFirmwares>(
      `${listFirmwaresUrl}`
    );
    return listFirmwaresResponse.data;
  } catch (error) {
    throw error;
  }
});

const firmwareSlice = createSlice({
  name: LIST_FIRMWARES,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFirmwareData.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(fetchFirmwareData.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.values = action.payload.values;
        state.message = action.payload.message;
      })
      .addCase(fetchFirmwareData.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
      });
  },
});

type Selector = {
  listFirmwareApi: ReturnType<typeof firmwareSlice.reducer>;
};

export const selector = (store: Selector) => store["listFirmwareApi"];

export default firmwareSlice.reducer;
